import { useCallback, useEffect, useState } from "react";

const useWindowSize = () => {
  const isClient = typeof window === "object";
  const [windowSize, setWindowSize] = useState({
    innerWidth: 0,
    innerHeight: 0,
  });

  const getWindowSize = useCallback(() => {
    return { innerWidth: window.innerWidth, innerHeight: window.innerHeight };
  }, []);

  useEffect(() => {
    const windowSize = isClient
      ? getWindowSize()
      : { innerWidth: 0, innerHeight: 0 };
    setWindowSize(windowSize);
  }, [getWindowSize, isClient]);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [isClient, getWindowSize]);

  return windowSize;
};

export default useWindowSize;
